// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_jRE19 { 
  flex : 0 0 auto;
  height : 100%;
  width: 36%;
  object-fit : contain;
  background : var( --color-white );
  padding : 8px 16px;
}

.title_BBdXY {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width : 217px;
}

.container_aXX_I {
  height: 130px;
  align-items: center;
}

.info_obRUI {
  width: 64%;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/attributes/image/resourceImage/ResourceImageEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".image { \n  flex : 0 0 auto;\n  height : 100%;\n  width: 36%;\n  object-fit : contain;\n  background : var( --color-white );\n  padding : 8px 16px;\n}\n\n.title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width : 217px;\n}\n\n.container {\n  height: 130px;\n  align-items: center;\n}\n\n.info {\n  width: 64%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_jRE19`,
	"title": `title_BBdXY`,
	"container": `container_aXX_I`,
	"info": `info_obRUI`
};
export default ___CSS_LOADER_EXPORT___;
